import React from "react";
import { useNavigate } from "react-router-dom";
import AdminNavbar from "../components/AdminNavbar";
import AdminSidebar from "../components/AdminSidebar";
import { useSidebar } from '../components/SidebarContext';

const AdminResultPage = () => {
  const { isSidebarOpen } = useSidebar();
  const sidebarWidth = isSidebarOpen ? '15.6rem' : '4.4rem';
  const navigate = useNavigate();

  // Sample student result data
  const studentResults = [
    {
      _id: "1",
      studentName: "John Doe",
      sectionName: "Mathematics",
      grade: "A",
    },
    {
      _id: "2",
      studentName: "Jane Smith",
      sectionName: "Science",
      grade: "B",
    },
    {
      _id: "3",
      studentName: "Alice Johnson",
      sectionName: "English",
      grade: "C",
    },
  ];

  // Inline styles (unchanged)
  const pageStyle = {
    minHeight: "100vh",
    background: "linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF)",
    display: "flex",
  };

  const cardStyle = {
    backgroundColor: "white",
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    borderRadius: "1rem",
    width: "100%",
    padding: "2.5rem",
    margin: "2rem",
  };

  const titleStyle = {
    fontSize: "2.25rem",
    fontWeight: "bold",
    color: "#7E22CE",
    marginBottom: "2rem",
    textAlign: "center",
  };

  const tableContainerStyle = {
    overflowX: "auto",
  };

  const tableStyle = {
    width: "100%",
    fontSize: "1.125rem",
    border: "1px solid #D1D5DB",
  };

  const thStyle = {
    border: "1px solid #D1D5DB",
    padding: "1rem",
    backgroundColor: "#F3E8FF",
    color: "#6B21A8",
  };

  const tdStyle = {
    border: "1px solid #D1D5DB",
    padding: "1rem",
  };

  const tdCenterStyle = {
    ...tdStyle,
    textAlign: "center",
  };

  const tdNameStyle = {
    ...tdStyle,
    fontWeight: "500",
    color: "#374151",
  };

  const tdGradeStyle = {
    ...tdCenterStyle,
    fontWeight: "700",
    color: "#16A34A",
  };

  const buttonStyle = {
    backgroundColor: "#4169E1",
    color: "white",
    padding: "0.5rem 1rem",
    border: "none",
    borderRadius: "0.375rem",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  };

  const emptyMessageStyle = {
    color: "#6B7280",
    marginTop: "1.5rem",
    textAlign: "center",
    fontSize: "1.25rem",
  };

  // Handle view result navigation
  const handleViewResult = (studentId) => {
    navigate(`/admin/result/${studentId}`);
  };

  return (
    <div style={pageStyle}>
      {/* Sidebar */}
      <div style={{ position: "fixed", top: 0, left: 0, height: "100%", width: sidebarWidth, zIndex: 10, transition: 'width 0.3s ease' }}>
        <AdminSidebar />
      </div>

      {/* Main content */}
      <div style={{ marginLeft: sidebarWidth, marginTop: "55px", width: `calc(100% - ${sidebarWidth})`, transition: 'all 0.3s ease' }}>
        {/* Navbar */}
        <AdminNavbar />

        <div style={cardStyle}>
          <h1 style={titleStyle}>📊 Student Results</h1>

          <div style={tableContainerStyle}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>#</th>
                  <th style={thStyle}>Student Name</th>
                  <th style={thStyle}>Section Name</th>
                  <th style={thStyle}>Grade</th>
                  <th style={thStyle}>Action</th>
                </tr>
              </thead>
              <tbody>
                {studentResults.map((result, index) => (
                  <tr
                    key={result._id}
                    style={{
                      backgroundColor: index % 2 === 0 ? "white" : "#F9FAFB",
                      transition: "background-color 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor = "#DCFCE7";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor =
                        index % 2 === 0 ? "white" : "#F9FAFB";
                    }}
                  >
                    <td style={tdCenterStyle}>{index + 1}</td>
                    <td style={tdNameStyle}>{result.studentName}</td>
                    <td style={tdNameStyle}>{result.sectionName}</td>
                    <td style={tdGradeStyle}>{result.grade}</td>
                    <td style={tdCenterStyle}>
                      <button
                        style={buttonStyle}
                        onClick={() => handleViewResult(result._id)}
                        onMouseOver={(e) =>
                          (e.target.style.backgroundColor = "#5B21B6")
                        }
                        onMouseOut={(e) =>
                          (e.target.style.backgroundColor = "#4169E1")
                        }
                      >
                        View Result
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {studentResults.length === 0 && (
              <p style={emptyMessageStyle}>No student results available.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminResultPage;